import React from "react";

import { Tooltip, Typography } from "@mui/material";

import { ReactionHighlight } from "@app/common/types";

import { Column } from "@rui/Stack";

const AnnotatedTextTooltip = ({
  children,
  content,
}: {
  children: React.ReactElement;
  content: ReactionHighlight["score"];
}) => {
  const tooltipTitle = (
    <Column variant="left">
      <Typography
        key={content.metric}
        variant="disclaimer"
        sx={{ fontWeight: 500, lineHeight: 16 / 12 }}
      >
        {content.value} {content.description}
      </Typography>
    </Column>
  );

  return (
    <Tooltip arrow followCursor placement="bottom-start" title={tooltipTitle}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default AnnotatedTextTooltip;
